import React from 'react';
import ReactDOM from 'react-dom';
import { Switch } from 'react-router-dom';

import Header from '../src/containers/Header';
import Footer from '../src/components/Footer';

import * as Env from './env';
import makeSwitchRoutes from './makeSwitchRoutes';

export default function App() {
  return (
    <div className="dp-content-wrapper">
      <div className="dp-content">
        <Header />
        <Switch>
          {makeSwitchRoutes()}
        </Switch>
      </div>
      <Footer />
    </div>
  );
}


if (process.env.REACT_AXE_ENV === 'local' && Env.REACT_AXE_ENABLED) {
  // eslint-disable-next-line
  const axe = require('react-axe');
  axe(React, ReactDOM, 5000);
}